<template>
  <div class="DeviceAccounts" v-loading="loading">
    <div class="center">
      <div
        style="
          height: 100%;
          width: calc(100%);
          padding-top: 10px;
          padding-left: 5px;
          padding-right: 5px;
          box-sizing: border-box;
        "
        class="tab-content"
      >
        <el-tabs
          v-model="activeName"
          type="card"
          @tab-click="handleClick"
          style="position: relative"
        >
          <el-tab-pane label="维检" name="1">
            <MaintainInfo
              ref="MaintainInfo"
              v-if="activeName === '1'"
              @WorkOrder="calendarData"
              @openView="openView"
            ></MaintainInfo>
          </el-tab-pane>

          <el-tab-pane label="设备" name="3">
            <div v-if="activeName === '3'" style="width: 100%; height: 100%">
              <div class="div-top div-top-but" style="margin-top: 10px">
                <div class="class-name">
                  <el-button
                    icon="el-icon-plus"
                    type="primary"
                    @click="handleAdd"
                    style="margin-left: 10px"
                    >新建设备</el-button
                  >

                  <el-dropdown
                    style="margin-left: 10px; margin-right: 10px"
                    @command="handleWorkOrder"
                  >
                    <el-button type="primary" icon="el-icon-plus"
                      >新建工单</el-button
                    >
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="1">
                        <el-button>保养工单</el-button>
                      </el-dropdown-item>
                      <el-dropdown-item command="0" style="margin-top: 10px">
                        <el-button>巡检工单</el-button>
                      </el-dropdown-item>
                      <el-dropdown-item
                        command="2"
                        style="margin-top: 10px; margin-bottom: 10px"
                      >
                        <el-button>维修工单</el-button>
                      </el-dropdown-item>
                      <el-dropdown-item
                        command="3"
                        style="margin-top: 10px; margin-bottom: 10px"
                      >
                        <el-button>外委工单</el-button>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-button
                    type="primary"
                    icon="el-icon-menu"
                    @click="handleInspection"
                    >工单记录</el-button
                  >

                  <!-- <el-button
                    type="primary"
                    icon="el-icon-menu"
                    @click="handleEnergy"
                    >&nbsp;&nbsp;能&nbsp;&nbsp;&nbsp;&nbsp;耗</el-button
                  > -->
                  <el-button
                    type="primary"
                    icon="el-icon-menu"
                    @click="handleCost"
                    >运维成本</el-button
                  >
                  <el-button
                    type="primary"
                    icon="el-icon-menu"
                    @click="handleMaterial"
                    >备件库存
                  </el-button>

                  <el-dropdown
                    style="margin-left: 10px; margin-right: 10px"
                    @command="(e) => handleEditStatus('开机停机', e)"
                  >
                    <el-button type="primary" icon="el-icon-menu"
                      >&nbsp;停 开 机</el-button
                    >
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="0">
                        <el-button style="width: 100%">停 开 机</el-button>
                      </el-dropdown-item>
                      <el-dropdown-item command="1" style="margin-top: 10px">
                        <el-button style="width: 100%">停开机记录</el-button>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-button
                    type="primary"
                    icon="el-icon-menu"
                    @click="handleEditStatus('故障')"
                    >&nbsp;&nbsp;报 故 障</el-button
                  >
                  <el-button
                    type="primary"
                    icon="el-icon-menu"
                    @click="handleStatus('报废')"
                    >&nbsp;&nbsp;报&nbsp;&nbsp;&nbsp;&nbsp;废</el-button
                  >
                </div>
                <div class="class-name">
                  <el-button
                    type="warning"
                    icon="el-icon-printer"
                    @click="openPrint"
                    >标签打印</el-button
                  >

                  <el-button
                    type="warning"
                    icon="el-icon-download"
                    @click="handleExport"
                    >数据导出</el-button
                  >
                </div>
              </div>
              <div class="div-top" style="margin-top: 10px">
                <!-- <el-input
                  v-model="searchData.Name"
                  placeholder="请输入设备编号或名称或生产厂家或维修商"
                  style="width: 250px; margin-left: 10px"
                ></el-input> -->

                <el-input
                  v-model="searchData.DeviceCode"
                  clearable
                  placeholder="请输入设备编号/名称"
                  style="width: 250px; margin-left: 10px"
                ></el-input>

                <el-input
                  v-model="searchData.SupplierName"
                  clearable
                  placeholder="请输入供应商/生产厂家/维修商名称"
                  style="width: 250px; margin-left: 10px"
                ></el-input>
                <el-input
                  v-model="searchData.BuildingFloor"
                  clearable
                  placeholder="请输入楼层名称"
                  style="width: 250px; margin-left: 10px"
                ></el-input>

                <SelectData
                  v-model="searchData.State"
                  :locationOptions="[
                    { label: '停机', Id: '0' },
                    { label: '开机', Id: '1' },

                    { label: '报废', Id: '3' },
                  ]"
                  placeholder="请选择设备状态"
                  style="width: 230px; margin-left: 10px"
                ></SelectData>
                <el-date-picker
                  v-model="searchData.purchase_date"
                  type="monthrange"
                  style="width: 250px; margin-left: 10px"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="安装开始日期"
                  end-placeholder="安装结束日期"
                  @change="handleDateChange"
                >
                </el-date-picker>
                <el-checkbox
                  v-model="searchData.IsFault"
                  style="margin-left: 20px"
                  @change="handleSearch"
                  >故障</el-checkbox
                >
                <el-button
                  type="primary"
                  @click="handleSearch"
                  style="margin-left: 30px"
                  >查询</el-button
                >
              </div>
              <div class="div-center">
                <el-table
                  :data="tableData"
                  ref="tableDiv"
                  style="width: 100%"
                  :class="type == 'checkBox' ? 'checkBoxTable' : 'radioTable'"
                  height="calc(100% - 50px)"
                  @select="handleSelect"
                  @row-click="handleRowClick"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column label="" width="50" type="selection">
                  </el-table-column>
                  <el-table-column label="序号" width="50" type="index">
                  </el-table-column>

                  <el-table-column
                    label="设备编号"
                    align="center"
                    prop="DeviceCode"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="设备名称"
                    align="center"
                    prop="device_name"
                    sortable
                  >
                  </el-table-column>
                  <!-- <el-table-column
                    label="设备型号"
                    align="center"
                    prop="model_number"
                    sortable
                  >
                  </el-table-column> -->
                  <el-table-column
                    label="设备规格"
                    align="center"
                    prop="specification"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="安装日期"
                    align="center"
                    prop="purchase_date"
                    sortable
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.purchase_date
                          ? moment(scope.row.purchase_date).format('YYYY-MM-DD')
                          : ''
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="供应商名称"
                    align="center"
                    prop="SupplierName"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="生产厂家名称"
                    align="center"
                    prop="manufacturer"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="维修商名称"
                    align="center"
                    prop="maintenance"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="安装位置"
                    align="center"
                    prop="InstallationAreaName"
                    sortable
                  >
                  </el-table-column>

                  <!-- <el-table-column label="购置价格" align="center" prop="purchase_price">
        </el-table-column> -->

                  <el-table-column
                    label="状态"
                    align="center"
                    prop="State"
                    sortable
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.State == 0">停机</el-tag>
                      <el-tag type="success" v-if="scope.row.State == 1"
                        >开机</el-tag
                      >
                      <el-tag type="warning" v-if="scope.row.State == 2"
                        >故障</el-tag
                      >
                      <el-tag type="danger" v-if="scope.row.State == 3"
                        >报废</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="是否故障"
                    align="center"
                    prop="IsFault"
                    sortable
                  >
                    <template slot-scope="scope">
                      <el-tag type="warning" v-if="scope.row.IsFault == 1"
                        >故障</el-tag
                      >
                      <el-tag type="success" v-if="scope.row.IsFault == 0"
                        >正常</el-tag
                      >
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                      <el-dropdown>
                        <span class="el-dropdown-link">
                          <span style="font-size: 12px">操作</span
                          ><i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <div style="width: 80px">
                            <el-button
                              type="text"
                              v-if="scope.row.State != 3"
                              @click="handleEdit(scope.row)"
                              style="
                                width: 100%;
                                display: block;
                                margin-left: 0;
                              "
                              >编辑</el-button
                            >
                            <el-button
                              type="text"
                              @click.stop="handleView(scope.row)"
                              style="
                                width: 100%;
                                display: block;
                                margin-left: 0;
                              "
                              >详情</el-button
                            >
                            <el-button
                              type="text"
                              @click.stop="handleCopy(scope.row)"
                              style="
                                color: #e6a23c;
                                width: 100%;
                                display: block;
                                margin-left: 0;
                              "
                              >复制</el-button
                            >
                            <!-- <el-button
                              type="text"
                              @click.stop="handleEditStatus('故障', scope.row)"
                              style="
                                color: #909399;
                                width: 100%;
                                display: block;
                                margin-left: 0;
                              "
                              >报故障</el-button
                            >
                            <el-button
                              type="text"
                              @click.stop="
                                handleEditStatus('开机停机', scope.row)
                              "
                              style="
                                color: #409eff;
                                width: 100%;
                                display: block;
                                margin-left: 0;
                              "
                              >开机/停机</el-button
                            > -->
                            <el-button
                              v-if="scope.row.State != 3"
                              type="text"
                              @click.stop="handleDetele(scope.row)"
                              style="
                                color: #f56c6c;
                                width: 100%;
                                display: block;
                                margin-left: 0;
                              "
                              >删除</el-button
                            >
                            <!-- <el-button type="text" @click.stop="">资产</el-button> -->
                          </div>
                        </el-dropdown-menu>
                      </el-dropdown>

                      <!-- <el-button
                  type="text"
                  @click="handleDetele([scope.row])"
                  style="color: #f78989"
                  >删除</el-button
                > -->
                    </template>
                  </el-table-column>
                </el-table>
                <div
                  style="
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: right;
                  "
                >
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagination.PageIndex"
                    :page-sizes="pagination.PageSizes"
                    :page-size="pagination.PageRows"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="运维成本" name="2">
            <EnergyInfo ref="EnergyInfo" v-if="activeName === '2'"></EnergyInfo>
          </el-tab-pane>
          <el-tab-pane label="设备文档" name="4">
            <FileInfo ref="FileInfo" v-if="activeName === '4'"></FileInfo>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <DevScheduleView
      ref="DevScheduleView"
      @success="handleSearch"
    ></DevScheduleView>
    <el-dialog
      title="选择设备分类"
      :visible.sync="dialogVisible"
      width="60%"
      top="5vh"
      @close="handleDialogClose"
    >
      <div style="font-size: 15px; line-height: 20px; height: 20px">
        请选择一个设备分类
      </div>
      <div
        style="width: 100%; height: calc(70vh - 20px); overflow-y: auto"
        v-loading="loading"
        class="dialogTree"
      >
        <el-tree
          :data="cascaderOptions"
          show-checkbox
          node-key="id"
          :default-expand-all="true"
          :props="defaultProps"
          ref="dialogTree"
          check-strictly
          @check="handleCheckChange"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span
              v-if="data.children && data.children.length > 0"
              style="font-weight: 1000; font-size: 16px"
            >
              <i class="el-icon-s-grid" style="font-size: 18px"></i>&nbsp;{{
                node.label
              }}</span
            >
            <span v-if="!data.children"
              ><i class="el-icon-receiving"></i> {{ node.label }}</span
            >
          </span>
        </el-tree>
      </div>
      <!-- <el-cascader
        style="width: 100%"
        filterable
        v-model="DeviceType"
        :options="cascaderOptions"
        :props="{
          emitPath: false,
          expandTrigger: 'hover',

          children: 'children',
          label: 'title',
          value: 'Id',
        }"
        clearable
      ></el-cascader> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
    <!-- 设备模板卡打印 -->
    <DevicePrint ref="DevicePrint"></DevicePrint>
    <!-- 设备工单 -->
    <DeviceEditForm ref="DeviceEditForm"></DeviceEditForm>
    <!-- 日历明细 -->
    <WorkOrder ref="WorkOrder"></WorkOrder>
    <!-- 备件详情 -->
    <Material ref="Material"></Material>
    <!-- 设备能耗详情 -->
    <Energy ref="Energy"></Energy>
    <!-- 运维成本 -->
    <DeviceCost ref="DeviceCost"></DeviceCost>

    <!-- 工单记录 -->
    <DeviceWorkOrderRecord ref="DeviceWorkOrderRecord"></DeviceWorkOrderRecord>
    <!-- 设备报故障 -->
    <OperationMalfunctionEditForm
      ref="OperationMalfunctionEditForm"
      @success="handleSearch"
    ></OperationMalfunctionEditForm>
    <!-- 开机停机 -->
    <OperationStopPowerEditForm
      ref="OperationStopPowerEditForm"
      @success="handleSearch"
    ></OperationStopPowerEditForm>
    <!-- 开停机记录 -->
    <DrawerOperationStopPower
      ref="DrawerOperationStopPower"
    ></DrawerOperationStopPower>
    <!-- 报废 -->
    <OperationScrapEditForm
      ref="OperationScrapEditForm"
      @success="handleSearch"
    ></OperationScrapEditForm>
  </div>
</template>
<script>
import DevScheduleView from './DevScheduleView.vue'
import DevicePrint from './DevicePrint.vue'
import WorkOrder from './WorkOrder.vue'
import Material from './Material.vue'

import DeviceWorkOrderRecord from './DeviceWorkOrderRecord/DeviceWorkOrderRecord.vue'
import Energy from './Energy.vue'
import DeviceCost from './DeviceCost.vue'
import EnergyInfo from './EnergyInfo/EnergyInfo.vue'
import MaintainInfo from './MaintainInfo/MaintainInfo.vue'
import DeviceEditForm from '@/views/Operation/OperationWorkOrder/EditForm.vue'
import OperationMalfunctionEditForm from '@/views/Operation/OperationMalfunction/EditForm.vue'
import OperationStopPowerEditForm from '@/views/Operation/OperationStopPower/EditForm.vue'
import DrawerOperationStopPower from '@/views/Operation/OperationStopPower/DrawerOperationStopPower.vue'
import OperationScrapEditForm from '@/views/Operation/OperationScrap/EditForm.vue'
import SelectData from '@/components/SelectData/SelectData.vue'
import FileInfo from './FileInfo/FileInfo.vue'
import tools from '@/utils/tools.js'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      upDataNum: 0, //组件更新
      dateCalendar: '',
      calendar: moment().format('YYYY-MM-DD'),
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      dialogVisible: false,
      DeviceType: '',
      activeIndex: '',
      cascaderOptions: [],
      searchData: {
        DeviceType: '',
        BuildingId: '',
        InstallationArea: '',
        DeviceCode: '',
        device_name: '',
        manufacturer: '',
        maintenance: '',
        purchase_date: [],
        State: '',
        SupplierName: '',
        BuildingFloor: '',
        IsFault: false,
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
      MenuList: [],
      type: 'checkBox', // checkBox 单选 radio 多选
      dataStatistics: {},
      activeName: '',
    }
  },
  props: {},
  components: {
    SelectData,
    DevScheduleView,
    DevicePrint,
    DeviceEditForm,
    DeviceWorkOrderRecord,
    WorkOrder,
    Material,
    Energy,

    DeviceCost,
    MaintainInfo,
    EnergyInfo,
    OperationMalfunctionEditForm,
    OperationScrapEditForm,
    OperationStopPowerEditForm,
    DrawerOperationStopPower,
    FileInfo,
  },
  methods: {
    handleDateChange(value) {
      // 无论是否为同一个月，结束日期都应为月末日期
      if (value && value.length === 2) {
        const startDate = moment(value[0])
        const endDate = moment(value[1])
        // 设置开始日期为选择月份的第一天
        const firstDay = startDate.startOf('month').format('YYYY-MM-DD')
        // 设置结束日期为选择月份的最后一天
        const lastDay = endDate.endOf('month').format('YYYY-MM-DD')
        this.$set(this.searchData, 'purchase_date', [firstDay, lastDay])
      }
    },
    openView(item) {
      this.$refs.WorkOrder.openView(item)
    },
    handleClick() {
      console.log(this.activeName)
      if (this.activeName === '3') {
        this.getDataList()
      }
    },
    handleEnergy() {
      if (this.selectedRows.length !== 1) {
        return this.$notify.error('请选择一个设备')
      }
      this.$refs.Energy.openForm('设备能耗详情', this.selectedRows[0])
    },
    handleInspection() {
      if (this.selectedRows.length !== 1) {
        return this.$notify.error('请选择一个设备')
      }
      this.$refs.DeviceWorkOrderRecord.openForm(
        '工单记录',
        this.selectedRows[0]
      )
    },

    handleCost() {
      if (this.selectedRows.length !== 1) {
        return this.$notify.error('请选择一个设备')
      }
      this.$refs.DeviceCost.openForm('运维成本', this.selectedRows[0])
    },

    handleMaterial() {
      if (this.selectedRows.length !== 1) {
        return this.$notify.error('请选择一个设备')
      }
      this.$refs.Material.openForm('备件详情', this.selectedRows[0])
    },
    handleCalendar(str) {
      this.$refs.calendar.selectDate(str)
      console.log(this.$refs.calendar.selectDate, 'this.$refs.calendar')
    },
    calendarData(item) {
      console.log(item)
      // console.log(date, "date");
      // setTimeout(() => {
      //   this.dateCalendar = moment(date).format("YYYY-MM-DD");
      // }, 1);
      if (item) {
        this.$refs.WorkOrder.openForm(item.WorkOrderDate + '日程列表', item)
      }
    },
    handleWorkOrder(command) {
      if (this.selectedRows.length !== 1) {
        return this.$notify.error('请选择一个设备')
      }
      let obj = this.selectedRows[0] || {}
      if (obj.State == 3) {
        return this.$notify.error('设备已报废不能选择')
      }

      this.$refs.DeviceEditForm.openForm(
        '新建工单',
        {},
        false,
        this.selectedRows[0],
        command
      )
    },
    openPrint() {
      if (this.selectedRows.length == 0) {
        return this.$notify.error('请选择设备')
      }
      this.$refs.DevicePrint.openForm('打印设备信息', this.selectedRows)
    },
    handleEditStatus(str, e) {
      if (this.selectedRows.length !== 1) {
        return this.$notify.error('请选择一个设备')
      }
      let obj = this.selectedRows[0] || {}
      if (obj.State == 3) {
        return this.$notify.error('设备已报废不能选择')
      }
      if (str === '故障') {
        this.$refs.OperationMalfunctionEditForm.openForm(
          '新建设备故障',
          {},
          this.selectedRows[0]
        )
      } else if (str === '开机停机') {
        if (e == '0') {
          this.$refs.OperationStopPowerEditForm.openForm(
            '新建开机/停机',
            {},
            this.selectedRows[0]
          )
        } else if (e == '1') {
          this.$refs.DrawerOperationStopPower.openView(
            '开机/停机记录',
            this.selectedRows[0]
          )
        }
      }
    },
    //故障 开机停机 报废
    handleStatus(str, row) {
      if (this.selectedRows.length !== 1) {
        return this.$notify.error('请选择一个设备')
      }
      let obj = this.selectedRows[0] || {}
      if (obj.State == 3) {
        return this.$notify.error('设备已报废不能选择')
      }
      if (str === '报废') {
        this.$refs.OperationScrapEditForm.openForm(
          '新建报废记录',
          {},
          this.selectedRows[0]
        )
      }
      // console.log(this.selectedRows);
      // if (this.selectedRows.length !== 1) {
      //   return this.$notify.error("请选择一个设备");
      // }
      // let row = this.selectedRows[0];
      // let type = "";
      // let State = "";
      // let strin = "";
      // if (str == "开机停机") {
      //   type = 2;
      //   if (row.State == 1) {
      //     State = 0;
      //     strin = `此操作将停机该设备, 请输入停机原因`;
      //   } else {
      //     State = 1;
      //     strin = `此操作将开机该设备, 请输入原因`;
      //   }
      // } else if (str == "故障") {
      //   type = 1;
      //   State = 2;
      //   strin = `此操作将故障该设备, 请输入故障原因`;
      // } else if (str == "报废") {
      //   type = 3;
      //   State = 3;
      //   strin = `此操作将报废该设备, 请输入报废原因`;
      // }
      // this.$prompt(strin, {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   closeOnClickModal: false,
      //   closeOnPressEscape: false,
      //   inputType: "textarea",
      //   inputValidator: (value) => {
      //     if (State == 1) {
      //       return true;
      //     } else if (!value) {
      //       return "原因不能为空";
      //     } else {
      //       return true;
      //     }
      //   },
      //   type: "warning",
      // }).then((value) => {
      //   console.log(value);

      //   this.loading = true;
      //   this.$http
      //     .post("/PB/PB_Project/SaveDeviceState", {
      //       Id: row.Id,
      //       Type: type,
      //       State: State,
      //       Remarks: value.value,
      //     })
      //     .then((resJson) => {
      //       this.loading = false;
      //       if (resJson.Success) {
      //         this.$notify.success("操作成功");
      //         this.getDataList();
      //       } else {
      //         this.$notify.error(resJson.Msg);
      //       }
      //     });
      // });
    },

    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate)

      this.$refs.dialogTree.setCheckedKeys(
        this.$refs.dialogTree.getCheckedNodes(),
        false
      )
      this.$refs.dialogTree.setCheckedKeys([data.id])
      this.DeviceType = data.id
      console.log(this.$refs.dialogTree.getCheckedNodes())
    },
    handleExport() {
      tools.download(
        this.$rootUrl +
          `/PB/PB_Project/DeviceExportToExcel?DeviceType=${
            this.searchData.DeviceType || ''
          }&BuildingId=${this.searchData.BuildingId || ''}&InstallationArea=${
            this.searchData.InstallationArea || ''
          }&Name=${this.searchData.Name || ''}&purchase_date=${
            this.searchData.purchase_date?.length > 0
              ? this.searchData.purchase_date.join(',')
              : ''
          }`,
        '设备台账',
        '.xlsx',
        'get'
      )
    },
    handleCommand() {},
    handleCopy(row) {
      this.$prompt(`此操作将复制该设备信息, 请输入复制数量`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        inputType: 'number',
        inputValue: 1,
        inputPattern: /^[1-9]\d*$/,
        inputPlaceholder: '请输入复制数量',
        type: 'warning',
      }).then((value) => {
        console.log(value)

        this.loading = true
        this.$http
          .post('/PB/PB_Project/CopyDeviceItem', {
            id: row.Id,
            Num: value.value,
          })
          .then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('复制成功')
              this.getDataList()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    handleDialogClose() {
      this.dialogVisible = false
    },
    handleSelect(selection, row) {
      console.log(selection, row)

      if (this.type == 'checkBox') {
        this.selectedRows = selection
        return
      }
      this.$refs.tableDiv.clearSelection()
      this.$refs.tableDiv.toggleRowSelection(row)
      this.selectedRows = [row]
    },
    handleSelectionChange(val) {
      console.log(val)
      if (this.type == 'checkBox') {
        this.selectedRows = val
        return
      }
    },
    handleRowClick(row) {
      if (this.type == 'checkBox') {
        this.$refs.tableDiv.toggleRowSelection(row)
        return
      }

      this.$refs.tableDiv.clearSelection()
      this.$refs.tableDiv.toggleRowSelection(row)
      this.selectedRows = [row]
    },
    getMenuList() {
      this.$http.post('/PB/PB_Project/GetProjectTreeData').then((resJson) => {
        if (resJson.Success) {
          this.MenuList = resJson.Data
        } else {
          this.$notify.error(resJson.Msg)
        }
      })
    },

    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/PB/PB_Project/GetProjectDevceList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'DeviceType',
              Keyword: this.devTreeSearch.DeviceType || '',
            },
            {
              Condition: 'BuildingId',
              Keyword: this.devTreeSearch.BuildingId || '',
            },
            {
              Condition: 'InstallationArea',
              Keyword: this.devTreeSearch.InstallationArea || '',
            },
            {
              Condition: 'TreeType',
              Keyword: this.devTreeSearch.TreeType || 0,
            },
            {
              Condition: 'DeviceCode',
              Keyword: this.searchData.DeviceCode,
            },

            {
              Condition: 'manufacturer',
              Keyword: this.searchData.manufacturer,
            },
            {
              Condition: 'maintenance',
              Keyword: this.searchData.maintenance,
            },
            {
              Condition: 'State',
              Keyword: this.searchData.State,
            },
            {
              Condition: 'SupplierName',
              Keyword: this.searchData.SupplierName,
            },
            {
              Condition: 'BuildingFloor',
              Keyword: this.searchData.BuildingFloor,
            },
            {
              Condition: 'IsFault',
              Keyword: this.searchData.IsFault ? 1 : 0,
            },
            {
              Condition: 'purchase_date',
              Keyword:
                this.searchData.purchase_date?.length > 0
                  ? this.searchData.purchase_date.join(',')
                  : '',
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              this.$refs.tableDiv.clearSelection()
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.dialogVisible = true
      this.DeviceType = ''
      this.$nextTick(() => {
        this.$refs.dialogTree.setCheckedKeys(
          this.$refs.dialogTree.getCheckedNodes(),
          false
        )
      })
      // this.$refs.EditForm.openForm("新建用户");
    },
    handleDetele(row) {
      // let ids = rows.map((item) => item.Id);
      this.$confirm(`此操作将永久删除该设备, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/PB/PB_Project/DeleteDeviceItem', {
              id: row.Id,
            })
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      // this.$refs.EditForm.openForm("编辑用户", row);
      this.$refs.DevScheduleView.openDrawer(row)
    },
    handleView(row) {
      this.$refs.DevScheduleView.openDrawer(row, true)
    },
    handleSubmit() {
      if (this.DeviceType == '') {
        this.$notify.error('请选择设备分类')
        return
      }
      this.dialogVisible = false
      this.$refs.DevScheduleView.openDrawer({
        DeviceType: this.DeviceType,
      })
    },
    getTreeData() {
      this.$http
        .post(
          '/PB/PB_Project/GetDictionaryTreeByDicKey?DicKey=EquipmentClassification',
          {}
        )
        .then((resJson) => {
          if (resJson.Success) {
            this.cascaderOptions = resJson.Data[0].children
            this.cascaderOptions.forEach((item) => {
              this.$set(item, 'disabled', true)
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
  },
  mounted() {},
  created() {
    // this.getDataList();
    // this.getMenuList();
    this.getTreeData()
    this.activeName = '1'
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    devTreeSearch() {
      if (this.activeName === '3') {
        this.pagination.PageIndex = 1
        this.getDataList()
      }
    },
    dateCalendar(a, b) {
      console.log(a, b)
      this.calendar = moment(a).format('YYYY-MM-DD')
      console.log(moment(a).format('YYYY-MM-DD'))
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  width: calc(100%);
  // height: 30px;
  line-height: 30px;
}
::v-deep .div-top-but {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-button {
    width: 100px;
  }
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 100px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
.el-menu-vertical-demo {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.DeviceAccounts {
  width: 100%;
  height: 100%;
  background: #fff;
  .center {
    width: 100%;
    height: 100%;
    display: flex;
  }
}
::v-deep
  .radioTable
  .el-table__header-wrapper
  .el-table-column--selection
  .cell {
  display: none;
}
::v-deep .el-dropdown-menu .el-button + .el-button {
  margin-left: 0px;
}

::v-deep .el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
// ::v-deep .dialogTree .el-tree-node__children .el-tree-node {
//   float: left;
// }
.div-Statistics {
  display: flex;
  align-items: center;
  position: relative;
  height: 160px;
}
.numSTa {
  height: 49%;
  .el-col {
    height: 100%;
  }
  .el-card {
    height: 100%;
    ::v-deep .el-card__body {
      height: 100%;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
    }
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    line-height: 30px;
  }
  .num {
    font-size: 24px;
    font-weight: bold;
    line-height: 60px;
    margin-left: 20px;
  }
}
::v-deep .el-calendar {
  .el-calendar__header {
    padding: 5px;
    display: none;
  }
  .el-calendar__body {
    padding: 0;
  }
  .el-calendar-table thead th {
    padding: 5px 0;
    font-size: 12px;
  }
  .el-calendar-day {
    height: auto;
    padding: 1px;
    text-align: center;
    font-size: 12px;
  }
  .is-today .el-calendar-day {
    background: #409eff;
    color: #fff;
  }
  .item {
    margin-bottom: 3px;
    line-height: 1;
  }
  // .is-selected .el-calendar-day {
  //   background: #409eff;
  //   color: #fff;
  // }
  // .is-selected .el-calendar-day {
  //   // background: #409eff;
  //   color: #409eff;
  // }
}
::v-deep .el-badge__content.is-fixed {
  position: absolute;
  top: -9px;
  right: -23px;
  transform: translateY(-50%) translateX(100%);
  font-size: 12px;
  transform: scale(0.5);
}
::v-deep .el-statistic {
  .con {
    margin-top: 10px;
    color: #e6a23c;
  }
}
::v-deep .tab-content {
  .el-tabs {
    height: calc(100%);
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__content {
      height: calc(100% - 40px);
      .el-tab-pane {
        height: 100%;
        box-sizing: border-box;
      }
    }
  }
}
</style>
